<template>
  <div class="change-device">
    <van-cell-group class="form-box">
      <van-field
        :value="$route.query.oldSn"
        label="原机具编号"
        placeholder="请输入原机具编号"
        readonly
      />
      <van-field
        v-model="newSn"
        label="新机具编号"
        placeholder="请输入新机具编号"
        @input="onInputNewSn"
      >
        <template v-if="false" #button>
          <img
            @click="onScan"
            class="iconScan"
            src="@/assets/img/icon_scan.png"
            alt=""
          />
        </template>
      </van-field>
    </van-cell-group>
    <div class="device-list">
      <div class="list-title">
        <div class="left">可选机具号</div>
        <div class="right">共{{ deviceList.length }}台</div>
      </div>
      <div class="list-content">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              v-for="(item, index) in deviceList"
              :key="index"
              @click="onChoose(item)"
              class="item"
            >
              <div class="left">
                <span class="start">{{ item.sn.substring(10, -1) }}</span>
                <span class="end">{{ item.sn.substring(10) }}</span>
              </div>
              <div class="right">
                <img
                  v-if="item.checked"
                  class="icon"
                  src="@/assets/img/icon_list_selected.png"
                  alt=""
                />
                <img
                  v-else
                  class="icon"
                  src="@/assets/img/icon-unselected.png"
                  alt=""
                />
              </div>
            </div>
            <div class="no-found" v-if="deviceList.length == 0">
              <img
                src="https://syfrontweb.oss-cn-hangzhou.aliyuncs.com/wechat/quguo-mina/public/no_data_f.png"
              />
              <div class="case">暂无数据！</div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <div @click="goNext" class="bottom-btn">
      <span class="text">下一步</span>
    </div>
  </div>
</template>

<script>
import { multiMachineList } from '@/api/merchant/merchant'
export default {
  name: 'change-device',

  data() {
    return {
      pageNo: 0,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,

      newSn: '',
      merInfo: {},
      deviceList: [],
      activeSn: {}
    }
  },

  mounted() {},

  methods: {
    onRefresh() {
      // 清空列表数据
      this.deviceList = []
      this.pageNo = 1
      this.finished = false
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      setTimeout(() => {
        this.refreshing = false
      }, 1500)
      this.getData()
    },
    onLoad() {
      this.pageNo++
      this.getData()
    },
    onInputNewSn(e) {
      console.log(e)
      if (e.length >= 10 || e == '') {
        this.onRefresh()
      }
    },
    getData() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        snCode: this.newSn,
        id: this.$route.query.id
      }
      console.log(params)
      multiMachineList(params)
        .then(res => {
          console.log(res)
          this.loading = false
          this.merInfo = res
          this.deviceList.push(...res.list.list)
          if (res.list.list.length < this.pageSize) {
            this.finished = true
          }
        })
        .catch(err => {
          this.finished = true
        })
    },
    onScan() {
      console.log('调用扫码')
      SyHybridSdk.scan({
        success: res => {
          // alert(JSON.stringify(res))
          this.newSn = res.resultData
        }
      })
    },
    onChoose(item) {
      this.deviceList.forEach(e => {
        if (item.sn == e.sn) {
          if (item.checked) {
            e.checked = false
            this.newSn = ''
          } else {
            e.checked = true
            this.newSn = item.sn
            this.activeSn = item
          }
        } else {
          e.checked = false
        }
      })
    },
    goNext() {
      if (!this.newSn) {
        this.$toast('请选择新机具!')
        return
      }
      this.$router.push({
        path: '/change-device-next',
        query: {
          ...this.$route.query,
          mer: this.merInfo.mer,
          merName: this.merInfo.merName,
          merSecretTel: this.merInfo.merSecretTel,
          oldSn: this.merInfo.oldSn,
          newSn: this.newSn,
          type: this.activeSn.type
        }
      })
    }
  }
}
</script>
